(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  function initializeEnquiry() {
  const section = document.querySelector('[data-section-type="product"][data-product-status]');
  if (!section) return;
  const sectionId = section.dataset.sectionId;
  const product = JSON.parse(document.getElementById('ProductJson-' + sectionId).textContent);
  const find = id => product.variants.find(v => String(v.id) === String(id));
  const dispatch = document.getElementById('YesgkDispatch-' + sectionId);
  const eligible = dispatch ? dispatch.dataset.eligibleVariants.split(',') : [];
  const marker = section.dataset.productStatus;
  const status = variant => ['cancelled', 'closed'].includes(marker) ? marker : variant?.available === false ? 'soldout' : marker;
  let pageVariant = find(section.dataset.initialVariant);
  function updatePage(next) {
    pageVariant = next;
    const state = status(next);
    const entry = next?.available === false ? section.dataset.entrySource : state === 'cancelled' ? section.dataset.entryCancelled : ['closed', 'soldout'].includes(state) ? section.dataset.entryStock : section.dataset.entryShipping;
    section.querySelectorAll('[data-enquiry-entry-label]').forEach(el => { el.textContent = entry; });
    section.querySelectorAll('[data-enquiry-source-note]').forEach(el => { el.hidden = next?.available !== false; });
    const icon = ['cancelled', 'closed', 'soldout'].includes(state) ? 'question' : 'shipping';
    section.querySelectorAll('[data-enquiry-icon]').forEach(el => { el.toggleAttribute('hidden', el.dataset.enquiryIcon !== icon); });
    section.querySelectorAll('[data-enquiry-dispatch]').forEach(el => { el.hidden = !next || el.dataset.enquiryDispatch !== state; });
    section.querySelectorAll('[data-enquiry-open]').forEach(el => { el.disabled = !next; });
    section.querySelectorAll('.yesgk-status-badge').forEach(el => {
      el.hidden = !next || state === 'unmarked';
      el.dataset.status = state;
      el.textContent = el.getAttribute('data-status-' + state) || '';
    });
    if (dispatch) dispatch.hidden = state !== 'instock' || !next?.available || !eligible.includes(String(next.id));
  }
  if (window.jQuery) window.jQuery(section).on('variantChange.yesgkEnquiry', event => updatePage(event.variant || null));
  section.addEventListener('variantChange', event => updatePage(event.detail?.variant || event.variant || null));
  updatePage(pageVariant);
  const dialog = document.getElementById('productInquiry');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const q = selector => dialog.querySelector(selector);
  const field = name => q('[data-enq-' + name + ']');
  const words = Object.fromEntries([...dialog.querySelectorAll('[data-word]')].map(el => [el.dataset.word, el.textContent]));
  const form = q('form'), version = field('version'), country = field('country'), zip = field('zip');
  const question = field('question'), note = field('note'), email = field('email'), submit = field('submit');
  const inputs = [country, question, email], error = field('send-error');
  let variant = pageVariant;
  let channel = 'whatsapp', topic = 'shipping', expanded = false, busy = false;
  let loadedCountries = false, storageAvailable = true, trigger, savedScroll = 0, savedStyle;
  let scrollLockStyles = [];
  const storageKey = 'yesgk-enquiry-preferences';
  try {
    const stored = JSON.parse(localStorage.getItem(storageKey) || '{}');
    if (stored.channel === 'email') channel = 'email';
    if (typeof stored.email === 'string' && !email.value) email.value = stored.email;
  } catch { storageAvailable = false; }
  function remember() {
    if (!storageAvailable) return;
    try { localStorage.setItem(storageKey, JSON.stringify({ channel, email: email.value })); }
    catch { storageAvailable = false; }
  }
  function clear(el) {
    el.removeAttribute('aria-invalid');
    document.getElementById(el.getAttribute('aria-describedby')).hidden = true;
  }
  function render() {
    const sourcing = variant?.available === false;
    field('title').textContent = sourcing ? words.sourceTitle : words.title;
    field('stock-label').textContent = sourcing ? words.sourceButton : words.stock;
    field('version-toggle').hidden = form.hidden || product.variants.length < 2;
    field('version-toggle').disabled = busy;
    dialog.dataset.compact = String(topic === 'shipping' && channel === 'whatsapp' && !expanded);
    field('shipping').hidden = topic !== 'shipping';
    field('question-field').hidden = topic !== 'other';
    field('email-field').hidden = channel !== 'email';
    email.required = channel === 'email';
    country.required = topic === 'shipping';
    question.required = topic === 'other';
    field('note-toggle').hidden = topic === 'other' || expanded;
    field('note-field').hidden = topic === 'other' || !expanded;
    field('note-toggle').setAttribute('aria-expanded', String(expanded));
    submit.textContent = busy ? words.sending : words[channel];
    field('helper').textContent = topic === 'stock' ? (sourcing ? words.sourceNote : words.stockHint) : words[channel + 'Hint'];
    q('[name="enquiry_channel"][value="' + channel + '"]').checked = true;
    q('[name="enquiry_topic"][value="' + topic + '"]').checked = true;
  }
  function choose(next, reset) {
    variant = next;
    if (!variant) return;
    version.value = String(variant.id);
    const state = status(variant), cancelled = state === 'cancelled', stock = ['closed', 'soldout'].includes(state);
    for (const name of ['stock', 'shipping']) {
      const label = field('topic-' + name);
      label.hidden = cancelled || (name === 'stock' ? !stock : stock);
      label.querySelector('input').disabled = label.hidden;
    }
    field('topics').dataset.single = String(cancelled);
    if (reset || topic !== 'other') topic = cancelled ? 'other' : stock ? 'stock' : 'shipping';
    field('sub').textContent = variant.title;
    if (question.value === words.sourceMessage && (variant.available !== false || !cancelled)) question.value = '';
    if (variant.available === false && cancelled && !question.value.trim()) question.value = words.sourceMessage;
    render();
  }
  function countries() {
    if (loadedCountries) return;
    const options = field('countries').content.querySelector('select');
    country.append(...[...options.children].map(option => option.cloneNode(true)));
    const match = [...country.options].find(option => option.value && (option.value === dialog.dataset.country || option.textContent === dialog.dataset.country));
    country.value = match ? match.value : '';
    loadedCountries = true;
  }
  function retainLockedScroll(event) {
    if (event.target === document) event.stopImmediatePropagation();
  }
  function show(push = true) {
    if (dialog.open) return;
    countries();
    if (push && form.hidden) {
      form.hidden = false;
      field('sent').hidden = true;
    }
    if (!busy && !form.hidden) choose(pageVariant, true);
    field('version-field').hidden = true;
    field('version-toggle').setAttribute('aria-expanded', 'false');
    trigger = document.activeElement;
    savedScroll = window.scrollY;
    if (push) history.pushState({ ...history.state, yesgkEnquiry: sectionId }, '');
    savedStyle = document.body.getAttribute('style');
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      const paddingRight = parseFloat(getComputedStyle(document.body).paddingRight);
      document.querySelectorAll('#header, .stickyCart, .lp-whatsapp-icon-bar, #site-scroll').forEach(el => {
        const style = getComputedStyle(el);
        if (style.position !== 'fixed') return;
        const right = style.right;
        scrollLockStyles.push({ el, style: el.getAttribute('style') });
        el.style.transition = 'none';
        if (el.matches('#header, .stickyCart')) el.style.width = 'calc(100% - ' + scrollbarWidth + 'px)';
        else el.style.right = parseFloat(right) + scrollbarWidth + 'px';
      });
      document.body.style.paddingRight = paddingRight + scrollbarWidth + 'px';
      window.addEventListener('scroll', retainLockedScroll, true);
    }
    Object.assign(document.body.style, { position: 'fixed', top: -savedScroll + 'px', width: '100%', overflow: 'hidden' });
    dialog.showModal();
    (form.hidden ? field('sent-title') : q('h2')).focus({ preventScroll: true });
  }
  function close(back = true) {
    if (!dialog.open) return;
    dialog.close();
    if (savedStyle === null) document.body.removeAttribute('style');
    else document.body.setAttribute('style', savedStyle);
    if (scrollLockStyles.length) {
      scrollLockStyles.forEach(({ el, style }) => {
        if (style === null) el.removeAttribute('style');
        else el.setAttribute('style', style);
        el.style.transition = 'none';
      });
      void document.body.offsetWidth;
      scrollLockStyles.forEach(({ el, style }) => {
        if (style === null) el.removeAttribute('style');
        else el.setAttribute('style', style);
      });
      scrollLockStyles = [];
    }
    window.removeEventListener('scroll', retainLockedScroll, true);
    window.scrollTo(0, savedScroll);
    (trigger?.matches('[data-enquiry-open]') ? trigger : section.querySelector('[data-enquiry-open]'))?.focus({ preventScroll: true });
    if (back && history.state?.yesgkEnquiry === sectionId) history.back();
  }
  function sent() {
    form.hidden = true;
    field('version-toggle').hidden = true;
    field('sent').hidden = false;
    field('sent-title').focus();
  }
  function message() {
    const url = new URL(dialog.dataset.productUrl);
    url.searchParams.set('variant', variant.id);
    const sourcing = variant.available === false && (topic === 'stock' || (marker === 'cancelled' && topic === 'other'));
    const lines = [sourcing ? words.sourceMessage : channel === 'email' ? words[topic] : words[topic + 'Request'], '', words.product + ': ' + (sourcing ? words.displayTitle : product.title), words.version + ': ' + variant.title];
    if (topic === 'shipping') lines.push(words.destination + ': ' + country.value + (zip.value.trim() ? ', ' + zip.value.trim() : ''));
    if (topic === 'other' && (!sourcing || question.value.trim() !== words.sourceMessage)) lines.push(words.question + ': ' + question.value.trim());
    if (topic !== 'other' && note.value.trim()) lines.push(words.note + ': ' + note.value.trim());
    lines.push(words.link + ': ' + url.href);
    field('body').value = lines.join('\n');
    return field('body').value;
  }
  function validate() {
    const invalid = inputs.filter(el => el.required && (!el.value.trim() || !el.checkValidity()));
    inputs.forEach(clear);
    for (const el of invalid) {
      el.setAttribute('aria-invalid', 'true');
      document.getElementById(el.getAttribute('aria-describedby')).hidden = false;
    }
    invalid[0]?.focus();
    return invalid.length === 0;
  }
  function failed(text) {
    error.textContent = text;
    error.hidden = false;
  }
  form.addEventListener('submit', event => {
    const emailChannel = channel === 'email';
    if (!emailChannel) event.preventDefault();
    if (busy) return;
    if (!variant || !validate()) { event.preventDefault(); return; }
    error.hidden = true;
    remember();
    const body = message();
    if (emailChannel) {
      const returnUrl = new URL(dialog.dataset.productUrl);
      returnUrl.searchParams.set('contact_posted', 'true');
      returnUrl.searchParams.set('variant', (pageVariant || variant).id);
      form.elements.return_to.value = returnUrl.pathname + returnUrl.search;
      const action = new URL(form.action);
      action.hash = '';
      form.action = action.href;
      busy = true;
      submit.disabled = true;
      field('fields').inert = true;
      form.setAttribute('aria-busy', 'true');
      render();
      close(false);
      const state = { ...history.state };
      delete state.yesgkEnquiry;
      history.replaceState(state, '', location.href);
      return;
    }
    let phone = dialog.dataset.whatsapp.trim();
    if (/^https?:\/\//i.test(phone)) {
      try {
        const link = new URL(phone);
        phone = link.searchParams.get('phone') || (link.hostname === 'wa.me' ? link.pathname : '');
      } catch { failed(words.whatsappUnavailable); return; }
    }
    const number = phone.replace(/\D/g, '');
    if (!number) { failed(words.whatsappUnavailable); return; }
    const url = 'https://wa.me/' + number + '?text=' + encodeURIComponent(body);
    if (matchMedia('(max-width: 767px)').matches) window.location.href = url;
    else window.open(url, '_blank', 'noopener');
  });
  form.addEventListener('change', event => {
    if (event.target === version) {
      choose(find(version.value), false);
      field('version-field').hidden = true;
      field('version-toggle').setAttribute('aria-expanded', 'false');
      field('version-toggle').focus({ preventScroll: true });
    }
    if (event.target.name === 'enquiry_channel') {
      channel = event.target.value;
      clear(email);
      error.hidden = true;
      remember();
      render();
    }
    if (event.target.name === 'enquiry_topic') {
      topic = event.target.value;
      inputs.forEach(clear);
      render();
    }
    if (event.target === country) clear(country);
    if (event.target === email) remember();
  });
  field('version-toggle').addEventListener('click', () => {
    const expanded = field('version-field').hidden;
    field('version-field').hidden = !expanded;
    field('version-toggle').setAttribute('aria-expanded', String(expanded));
    if (expanded) version.focus();
  });
  inputs.forEach(el => el.addEventListener('input', () => clear(el)));
  field('note-toggle').addEventListener('click', () => { expanded = true; render(); note.focus(); });
  section.querySelectorAll('[data-enquiry-open]').forEach(el => el.addEventListener('click', () => show()));
  dialog.querySelectorAll('[data-enq-close]').forEach(el => el.addEventListener('click', () => close()));
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
  });
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('button, input, select, textarea, a[href]')].filter(el => !el.disabled && !el.closest('[hidden], [inert]') && el.getClientRects().length);
    const first = focusable[0], last = focusable.at(-1);
    if (event.shiftKey && (document.activeElement === first || document.activeElement === q('h2'))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  window.addEventListener('popstate', () => {
    if (history.state?.yesgkEnquiry === sectionId) show(false);
    else close(false);
  });
  choose(pageVariant, true);
  const returnedUrl = new URL(location.href);
  const contactPosted = returnedUrl.searchParams.get('contact_posted') === 'true';
  if (contactPosted) {
    returnedUrl.searchParams.delete('contact_posted');
    if (returnedUrl.hash === '#prInquiry') returnedUrl.hash = '';
    history.replaceState(history.state, '', returnedUrl.pathname + returnedUrl.search + returnedUrl.hash);
  }
  if (contactPosted || q('[data-enquiry-result]')) {
    show();
    if (!q('[data-enquiry-result="error"]') && (contactPosted || q('[data-enquiry-result="success"]'))) sent();
    else {
      const previous = decodeURIComponent(field('previous').value.replace(/\+/g, ' ')).replace(/\r\n/g, '\n');
      const lines = previous.split('\n');
      const read = label => (label === words.link ? lines.findLast(line => line.startsWith(label + ': ')) : lines.find(line => line.startsWith(label + ': ')))?.slice(label.length + 2) || '';
      const id = read(words.link).match(/[?&]variant=(\d+)/)?.[1];
      const restored = find(id);
      if (restored) choose(restored, true);
      const restoredTopic = ['shipping', 'stock', 'other'].find(key => lines[0] === words[key + 'Request'] || lines[0] === words[key]) || (lines[0] === words.sourceMessage ? (marker === 'cancelled' ? 'other' : 'stock') : undefined);
      if (restoredTopic && !q('[name="enquiry_topic"][value="' + restoredTopic + '"]').disabled) topic = restoredTopic;
      const destination = read(words.destination).split(', ');
      country.value = destination.shift() || '';
      zip.value = destination.join(', ');
      const extract = (label, stop) => {
        const begin = previous.indexOf('\n' + label + ': ');
        if (begin < 0) return '';
        const end = previous.lastIndexOf('\n' + stop + ': ');
        return previous.slice(begin + label.length + 3, end < 0 ? undefined : end);
      };
      question.value = extract(words.question, words.link);
      if (variant?.available === false && marker === 'cancelled' && !question.value.trim()) question.value = words.sourceMessage;
      note.value = extract(words.note, words.link);
      if (!restoredTopic) { topic = 'other'; question.value = previous; }
      expanded = !!note.value;
      channel = 'email';
      render();
    }
  }
  }
  if (document.readyState === 'complete') initializeEnquiry();
  else document.addEventListener('DOMContentLoaded', initializeEnquiry, { once: true });
})();
  } catch(e) { console.error(e); }
})();

})();
